import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import '../App.css';
import ZeroHarm from '../components/ZeroHarm';
import ProjectSpotlight from '../components/ProjectSpotlight';
import Client from '../components/Client';
import { useNavigate } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react"

// Updated service bar data with descriptions

const serviceBarItems = [
    {
        label: 'Ship Management',
        icon: '🚢',
        description: 'Comprehensive commercial and technical ship management services.',
    },
    {
        label: 'Tug & Barge Operations',
        icon: '⚓',
        description: 'Harbor assistance and coastal transportation with tug & barge fleets.',
    },
    {
        label: 'Ship Drydock Services',
        icon: '🛠️',
        description: 'Scheduled drydocking for repairs, inspections, and maintenance.',
    },
    {
        label: 'Crew Manning & Supply',
        icon: '👨‍✈️',
        description: 'Provision of qualified officers and crew for global maritime operations.',
    },
    {
        label: 'Marine Technical Services',
        icon: '🧰',
        description: 'Expert diagnostics, repair, and technical support for vessels.',
    },
];



/// Sample service cards data inspired by McDermott's offerings
const serviceCards = [
    {
        image: '/images/offshore.webp',
        label: 'Ship Management',
        // description: 'Delivering excellence in shallow and deepwater projects from concept to commissioning.',
        icon: (
            <svg className="mcd-icon" fill="currentColor" viewBox="0 0 24 24">
                <path d="M3 20h18v-2H3v2zm0-4h18v-2H3v2zm6-10V4h6v2h5l-1 6H5L4 6h5zM6 9h12l.5-3h-13L6 9z" />
            </svg>

        ),
        link: '/services/ship-management'
    },
    {
        image: '/images/sustainability.webp',
        label: 'Tug & Barge Operations',
        // description: 'Innovating for cleaner energy with reduced carbon emissions.',
        icon: (
            <svg className="mcd-icon" fill="currentColor" viewBox="0 0 24 24">
                <path d="M3 13h18v2H3v-2zm3 3h12v5H6v-5zM4 6h16l-2 5H6L4 6z" />
            </svg>

        ),
        link: '/services/tug-barge-operations'
    },
    {
        image: '/images/engineering1.webp',
        label: 'Ship Drydock Services',
        // description: 'Integrated EPFC solutions for global energy projects.',
        icon: (
            <svg className="mcd-icon" fill="currentColor" viewBox="0 0 24 24">
                <path d="M2 20h20v2H2v-2zm2-4h16v2H4v-2zm1-9h14l1 7H4l1-7zm2 2v3h10v-3H7z" />
            </svg>

        ),
        link: '/services/drydock'
    },
    {
        image: '/images/crewmanning.webp',
        label: 'Crew Manning & Supply',
        // description: 'Integrated EPFC solutions for global energy projects.',
        icon: (
            <svg className="mcd-icon" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 12c2.21 0 4-1.79 4-4S14.21 4 12 4 8 5.79 8 8s1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
            </svg>

        ),
        link: '/services/crew'
    },
    {
        image: '/images/MarineTechnicalServices.webp',
        label: 'Marine Technical Services',
        // description: 'Integrated EPFC solutions for global energy projects.',
        icon: (
            <svg className="mcd-icon" fill="currentColor" viewBox="0 0 24 24">
                <path d="M22.7 19.3l-4.2-4.2 1.4-1.4-2.8-2.8-1.4 1.4-4.2-4.2 1.4-1.4-2.8-2.8-1.4 1.4-4.2-4.2L1.3 4.7l4.2 4.2-1.4 1.4 2.8 2.8 1.4-1.4 4.2 4.2-1.4 1.4 2.8 2.8 1.4-1.4 4.2 4.2 2.8-2.8z" />
            </svg>


        ),
        link: '/services/marine'
    },
    {
        image: '/images/VoyageRepair.webp',
        label: 'Voyage Repairs & Afloat Maintenance',
        // description: 'Integrated EPFC solutions for global energy projects.',
        icon: (
            <svg className="mcd-icon" fill="currentColor" viewBox="0 0 24 24">
                <path d="M16.24 7.76a6 6 0 00-8.48 8.48L2 22l2 2 5.76-5.76a6 6 0 008.48-8.48zM7 13a4 4 0 115.66 0A4 4 0 017 13z" />
            </svg>


        ),
        link: '/services/voyage'
    },
    // {
    //     image: '/images/engineering.webp',
    //     label: 'Bunker & Fresh Water Supply',
    //     description: 'Integrated EPFC solutions for global energy projects.',
    //     icon: (
    //         <svg className="mcd-icon" fill="currentColor" viewBox="0 0 24 24">
    //             <path d="M6 2h12v2h-1v18h-2V4h-6v18H7V4H6V2zm10 14h2v2h-2v-2z" />
    //         </svg>

    //     ),
    //     link:'/services/bunker'
    // },
    // {
    //     image: '/images/engineering.webp',
    //     label: 'Spare Parts Procurement & Delivery',
    //     description: 'Integrated EPFC solutions for global energy projects.',
    //     icon: (
    //         <svg className="mcd-icon" fill="currentColor" viewBox="0 0 24 24">
    //             <path d="M20.3 17.3l-1.4 1.4-2.6-2.6c-.3.1-.6.2-.9.2-.8 0-1.5-.3-2.1-.9l-1.3-1.3c-.6-.6-.9-1.3-.9-2.1 0-.3.1-.6.2-.9L5.3 5.3 6.7 3.9l13.6 13.4z" />
    //         </svg>

    //     ),
    //     link:'/services/spare'
    // },

];
const slideshowImages = [

    '/images/slide1.webp',
    '/images/slide2.webp',
    '/images/slide.webp',
    '/images/slide3.webp'
];

const Home = ({ setPage }) => {
    const [currentImage, setCurrentImage] = useState(0);
    const [hasInteracted, setHasInteracted] = useState(false);
    const navigate = useNavigate();
    const audioRef = useRef(null);

    // Image slideshow effect
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImage((prevIndex) => (prevIndex + 1) % slideshowImages.length);
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    // Audio autoplay workaround (requires user interaction)
    useEffect(() => {
        const enableAudio = () => {
            if (!hasInteracted && audioRef.current) {
                audioRef.current.play().catch((err) => {
                    console.warn("Audio play failed:", err);
                });
                setHasInteracted(true);
                window.removeEventListener('click', enableAudio);
                window.removeEventListener('scroll', enableAudio);
                window.removeEventListener('keydown', enableAudio);
            }
        };

        window.addEventListener('click', enableAudio);
        window.addEventListener('scroll', enableAudio);
        window.addEventListener('keydown', enableAudio);

        return () => {
            window.removeEventListener('click', enableAudio);
            window.removeEventListener('scroll', enableAudio);
            window.removeEventListener('keydown', enableAudio);
        };
    }, [hasInteracted]);

    const handleClick = () => {
        navigate('/services');
    };

    return (
        <div className="app">
            < Analytics/>
            {/* <Navbar setPage={setPage} /> */}
            <section className="mcd-hero">
                {/* Hero content */}
                <audio ref={audioRef} preload="auto">
                    <source src="/audio/blue-waves.mp3" type="audio/mpeg" />
                    Your browser does not support audio.
                </audio>

                <img
                    src={slideshowImages[currentImage]}
                    alt="Slideshow"
                    className="mcd-hero-slideshow"
                />
                <div className="mcd-overlay">
                    <h1 className="mcd-title">Where Every Voyage Begins with Trust</h1>
                    <p className="mcd-subtitle">Steered by trust. Driven by excellence.</p>
                    <button className="mcd-button" onClick={handleClick}>Explore Our Solutions</button>
                    <div className="mcd-mission-vision-section">
                        <div className="mcd-mv-block mcd-vision">
                            <h3>Our Vision</h3>
                            <p>
                                To become the most trusted and efficient ship management partner in the region, driving value through operational excellence, innovation and unwavering commitment to global maritime standards.
                            </p>
                        </div>
                        <div className="mcd-mv-block mcd-mission">
                            <h3>Our Mission</h3>
                            <p>
                                To deliver end-to-end ship management solutions that maximize vessel performance and profitability.
                                To maintain the highest standards of safety, compliance and environmental responsibility.
                                To support our clients with responsive, transparent and reliable services.
                                To invest in human capital, building a competent and committed maritime workforce.
                            </p>
                        </div>

                    </div>

                </div>
            </section>

            {/* Services Bar Section */}
            <section className="mcd-services-bar">
                <div className="mcd-services-bar-container">
                    {serviceBarItems.length > 0 ? (
                        serviceBarItems.map((item, idx) => (
                            <div key={idx} className="mcd-service-bar-item" style={{ '--index': idx }}>
                                <div className="mcd-service-bar-icon">{item.icon}</div>
                                <p className="mcd-service-bar-label">{item.label}</p>
                                <span className="mcd-service-bar-tooltip">{item.description}</span>
                            </div>
                        ))
                    ) : (
                        <p className="mcd-service-bar-fallback">No services available.</p> // Fallback
                    )}
                </div>
            </section>

            {/* Services Section */}
            <section className="mcd-services">
                <div className="mcd-container">
                    <h2 className="mcd-services-title">
                        Our Core Capabilities
                    </h2>
                    <div className="mcd-services-grid">
                        {serviceCards.map((card, idx) => (
                            <Link to={card.link} key={idx} className="mcd-service-card" style={{ '--index': idx }}>
                                {card.image && (
                                    <img
                                        src={card.image}
                                        alt={card.label}
                                        className="mcd-service-image"
                                        onError={(e) => { e.target.style.display = 'none'; }}
                                    />
                                )}
                                <div className="mcd-service-content">
                                    <div className="mcd-service-header">
                                        {card.icon}
                                        <h3 className="mcd-service-title">{card.label}</h3>
                                    </div>
                                    <p className="mcd-service-description">{card.description}</p>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>
            <ZeroHarm />
            <ProjectSpotlight />
            <Client />
            <Footer />
            <Analytics />
        </div>
    );
};

export default Home;